import apiHelper from './index';

const RTC_SERVERS_TTL_MS = 5 * 60 * 1000;

// In memory only: the list carries TURN credentials, so it must never be
// written to localStorage, sessionStorage or the persisted store.
// key -> { promise, expiresAt }; holds the in-flight request too, so
// concurrent opens share it.
const rtcServersCache = new Map();

// Includes the organization and user so a list fetched for a previous
// session is never reused for the current one.
const rtcServersCacheKey = (iceOptions) =>
  `${localStorage.getItem('organization')}:${localStorage.getItem('id')}:${iceOptions}`;

async function fetchRTCServers(iceOptions, spinner) {
  const [error, data] = await apiHelper.get(`offer/rtc_server_list/?server=${iceOptions}` , spinner);
  if (error) throw 'Error occurred while fetching servers';

  return data;
}

async function getRTCServers(iceOptions, spinner = false) {
  if (!iceOptions)
    iceOptions = ''

  const key = rtcServersCacheKey(iceOptions);
  let entry = rtcServersCache.get(key);
  if (!entry || entry.expiresAt <= Date.now()) {
    entry = {
      promise: fetchRTCServers(iceOptions, spinner),
      expiresAt: Date.now() + RTC_SERVERS_TTL_MS,
    };
    rtcServersCache.set(key, entry);
    // Never cache a failure.
    entry.promise.catch(() => {
      if (rtcServersCache.get(key) === entry) rtcServersCache.delete(key);
    });
  }

  const data = await entry.promise;
  // Each caller gets its own copy, so none can alter the cached list.
  return data && JSON.parse(JSON.stringify(data));
}

async function sendRTCOffer(payload, spinner = false) {
  return await apiHelper.post(`offer/create_new_offer/`, payload, false);
}

async function getRTCAnswer(connectionID) {
  return await apiHelper.get(`offer/update_offer/${connectionID}`, false);
}

async function closeConnection(connectionID, payload) {
  return await apiHelper.put(
    `offer/update_offer/${connectionID}`,
    payload,
    false
  );
}

async function getRTCOffer(uuid) {
  return await apiHelper.get(`offer/${uuid}`, false);
}
async function deleteRTCOffer(uuid) {
  return await apiHelper.remove(`offer/${uuid}`, false);
}

export default {
  getRTCServers,
  sendRTCOffer,
  getRTCAnswer,
  closeConnection,
  getRTCOffer,
  deleteRTCOffer
};
